<template>
  <div>
    <div class="contact-item" @click="handeItemClick">
      <span class="contact-item-icon">
        <i :class="open ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
      </span>
      <div>{{ title }}</div>
    </div>
    <div style="max-height: 470px; overflow-y: auto">
      <team-list-item v-for="(team, index) in imTeams" :key="index" :team="team" :open="open" :is-active="imActiveContact.teamId === team.teamId" @active-change="handleActiveChange" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TeamListItem from './TeamListItem.vue'
export default {
  name: 'TeamList',
  components: {
    TeamListItem
  },
  props: {
    title: '',
    imTeams: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState({
      imActiveContact: state => state.imActiveContact
    })
  },
  watch: {
  },
  methods: {
    handeItemClick () {
      this.open = !this.open
    },
    handleActiveChange (account) {
      this.$store.commit('changeImActiveContactMutation', { account, type: 'team' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact-item {
  display: flex;
  font-size: 14px;
  color: #333;
  padding: 12px;
  position: relative;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 5px;
}
.contact-item-icon {
  color: #b0b0b0;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/list/TeamList.vue